import { render, staticRenderFns } from "./BillWych.vue?vue&type=template&id=2e490d45&"
import script from "./BillWych.vue?vue&type=script&lang=js&"
export * from "./BillWych.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports